import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useWindowWidth from '@/use/useWindowWidth'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderPreview',
  setup(__props) {

const { screenLessValue } = useWindowWidth()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "mb-4" }, "Дополнительные доходы", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "margin-v-s" }, "Загрузите все необходимые документы по добавленным в заказ доходам.", -1))
  ], 64))
}
}

})